import {
    Button,
    Divider,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    makeStyles,
    Menu,
    MenuItem,
    Select,
    TextField,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { Add, MoreVert, Remove, Search } from "@material-ui/icons"
import { useSnackbar } from "../../../utils/notificacoes"
import { useEffect, useState } from "react"
import { ativarInativarMassa, salvarEdicaoEmMassa } from "../../../services/cardapio"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCardapioContext } from "./CardapioContext"
import { useCheckboxContext } from "./CheckboxContext"
import DialogConfirmacaoMassa from "./DialogConfirmacaoMassa"
import PaginatedList from "./paginacao"

const useStyles = makeStyles(theme => ({
    container: {
        // Largura ciente do menu: encolhe quando o drawer expande, senão o
        // conteúdo (mais largo que o espaço) transborda para a esquerda sob o menu.
        width: "calc(100vw - var(--drawer-width, 80px) - 17px)",
        transition: "width 0.2s ease",
        height: "calc(100vh - 95px)",
        backgroundColor: "white",
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        textAlign: "left",
        padding: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            marginTop: "3.5rem",
            width: "100vw",
            height: "100vh",
            borderRadius: 0,
            padding: theme.spacing(2, 1.5),
            marginBottom: 0,
            boxShadow: "none",
        },
    },
    header: {
        marginBottom: theme.spacing(3),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(2),
            "& h4": {
                fontSize: "1.5rem",
            },
        },
    },
    searchField: {
        backgroundColor: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        "& .MuiOutlinedInput-root": {
            borderRadius: 25,
            border: "none !important",
            outline: "none !important",
            "& fieldset": {
                border: "none !important",
                outline: "none !important",
            },
            "&:hover fieldset": {
                border: "none !important",
                outline: "none !important",
            },
            "&.Mui-focused fieldset": {
                border: "none !important",
                outline: "none !important",
            },
        },
        "& .MuiInputBase-root": {
            border: "none !important",
            outline: "none !important",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
            outline: "none !important",
        },
    },
    botaoSalvar: {
        borderRadius: 25,
        backgroundColor: "var(--cor-botao-salvar)",
        color: "white",
        padding: theme.spacing(1.5, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(var(--cor-botao-salvar-rgb), 0.3)",
        "&:hover": {
            backgroundColor: "var(--cor-botao-salvar-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(var(--cor-botao-salvar-rgb), 0.4)",
        },
    },
    botaoAtivar: {
        borderRadius: 25,
        backgroundColor: "#2196f3",
        color: "white",
        padding: theme.spacing(1.5, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
        "&:hover": {
            backgroundColor: "#1976d2",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(33, 150, 243, 0.4)",
        },
    },
    botaoPDVDesativado: {
        borderRadius: 25,
        backgroundColor: "white",
        color: "black",
        padding: theme.spacing(1.5, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
    },
    botaoPDVAtivado: {
        borderRadius: 25,
        backgroundColor: "#FFEEBC",
        color: "black",
        padding: theme.spacing(1.5, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
    },
    botaoDesativar: {
        borderRadius: 25,
        backgroundColor: "var(--cor-erro)",
        color: "white",
        padding: theme.spacing(1.5, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(244, 67, 54, 0.3)",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(244, 67, 54, 0.4)",
        },
    },
    botaoMarcar: {
        borderRadius: 25,
        backgroundColor: "#9c27b0",
        color: "white",
        padding: theme.spacing(1.5, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(156, 39, 176, 0.3)",
        "&:hover": {
            backgroundColor: "#7b1fa2",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(156, 39, 176, 0.4)",
        },
    },
    containerList: {
        flexGrow: 1,
        overflow: "auto",
        [theme.breakpoints.down("sm")]: {
            marginLeft: theme.spacing(-1.5),
            marginRight: theme.spacing(-1.5),
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
    },
    divider: {
        margin: theme.spacing(2, 0),
        backgroundColor: "#f1f3f4",
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(1.5, 0),
        },
    },
    valorField: {
        backgroundColor: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderRadius: 15,
        "& .MuiOutlinedInput-root": {
            borderRadius: 15,
        },
    },
    mobileMenuButton: {
        backgroundColor: "#2196f3",
        color: "white",
        borderRadius: "50%",
        padding: theme.spacing(1.5),
        boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
        "&:hover": {
            backgroundColor: "#1976d2",
            transform: "scale(1.05)",
            boxShadow: "0 6px 20px rgba(33, 150, 243, 0.4)",
        },
    },
    menuPaper: {
        borderRadius: 15,
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        marginTop: theme.spacing(1),
    },
    menuItem: {
        padding: theme.spacing(1.5, 2),
        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    botaoBusca: {
        backgroundColor: "#2196f3",
        color: "white",
        borderRadius: "50%",
        padding: theme.spacing(1.2),
        boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
        "&:hover": {
            backgroundColor: "#1976d2",
            boxShadow: "0 6px 20px rgba(33, 150, 243, 0.4)",
        },
    },
}))

export default function EdicaoEmMassa() {
    const { items, setItems, handleCadastrarImagem, estabelecimento } = useCardapioContext()
    const autorizacao = localStorage.getItem("chaveSistema")
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

    const setLoading = useLoadingStore(s => s.setLoading)

    const [textoBusca, setTextoBusca] = useState("")
    const [valorPesquisa, setValorPesquisa] = useState("")
    const [resetPagination, setResetPagination] = useState(false)
    const [novaAtividade, setNovaAtividade] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null)

    const handleOpenMenu = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const procurarProduto = () => {
        setValorPesquisa(textoBusca.trim().toLowerCase())
        setResetPagination(prev => !prev)
    }

    const handleBuscaKeyDown = e => {
        if (e.key === "Enter") {
            procurarProduto()
        }
    }

    const handleInputChange = (id, newValue) => {
        const numericValue = newValue.replace(/\D/g, "")

        const formattedValue = numericValue ? (parseInt(numericValue, 10) / 100).toFixed(2) : "0.00"

        const updatedItems = items.map(item =>
            item.id === id ? { ...item, valor: formattedValue } : item
        )
        setItems(updatedItems)
    }

    const [categoriaSelecionada, setCategoriaSelecionada] = useState(null)

    const handleChangeCategoriaSelecionada = e => {
        setCategoriaSelecionada(e.target.value)
    }

    const [itensMostrar, setItensMostrar] = useState(items)
    const [filtroPDV, setFiltroPDV] = useState(false)

    useEffect(() => {
        if (categoriaSelecionada) {
            if (valorPesquisa) {
                setItensMostrar(
                    items?.filter(
                        item =>
                            item.categoria === categoriaSelecionada &&
                            item.nome.toLowerCase().includes(valorPesquisa) &&
                            (!filtroPDV || item.codigoPDV == null || item.codigoPDV == "")
                    )
                )
            } else {
                setItensMostrar(
                    items?.filter(
                        item =>
                            item.categoria === categoriaSelecionada &&
                            (!filtroPDV || item.codigoPDV == null || item.codigoPDV == "")
                    )
                )
            }
        } else {
            if (valorPesquisa) {
                setItensMostrar(
                    items?.filter(
                        item =>
                            item.nome.toLowerCase().includes(valorPesquisa) &&
                            (!filtroPDV || item.codigoPDV == null || item.codigoPDV == "")
                    )
                )
            } else {
                setItensMostrar(items?.filter(item => !filtroPDV || item.codigoPDV == ""))
            }
        }
    }, [categoriaSelecionada, items, valorPesquisa, filtroPDV])

    const classes = useStyles()
    const { checkedItems, selectAll, deselectAll } = useCheckboxContext()

    const handleSelectAll = () => {
        selectAll(itensMostrar)
    }
    const handleDeselectAll = () => {
        deselectAll()
    }

    const [alterarValor, setAlterarValor] = useState()
    const handleChangeAlterarValor = e => {
        const value = e.target.value

        if ((!isNaN(value) && parseFloat(value) >= 0) || value === "") {
            setAlterarValor(value)
        }
    }

    const acrescentar = () => {
        const updatedItems = items.map(item => {
            if (item.tipo === "P" || item.tipo === "O") {
                if (checkedItems[item.id] === true) {
                    const novoValor = (Number(item.valor) + Number(alterarValor)).toFixed(2)
                    return { ...item, valor: novoValor }
                }
            }
            return item
        })

        setItems(updatedItems)
    }

    const decrementar = () => {
        const updatedItems = items.map(item => {
            if (item.tipo === "P" || item.tipo === "O") {
                if (checkedItems[item.id] === true) {
                    const novoValor = (Number(item.valor) - Number(alterarValor)).toFixed(2)
                    return { ...item, valor: novoValor }
                }
            }
            return item
        })

        setItems(updatedItems)
    }

    const desativar = async () => {
        setLoading(true)

        const data = items.reduce((acc, item) => {
            if (checkedItems[item.id] && item) {
                acc.push({ id: item.id, tipo: item.tipo, ativo: false })
            }
            return acc
        }, [])

        if (data.length > 0) {
            const response = await ativarInativarMassa(estabelecimento.id, data, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                const idsToUpdate = new Set(data.map(itemData => itemData.id))

                items.forEach(item => {
                    if (item?.id && idsToUpdate.has(item.id)) {
                        item.ativo = false
                    } else if (item?.id && idsToUpdate.has(item?.id)) {
                        item.ativo = false
                    }
                })
                alertStart("Disponibilidade dos itens alterada com sucesso", "success")
            }
        }

        setLoading(false)
    }

    const ativar = async () => {
        setLoading(true)

        const data = items.reduce((acc, item) => {
            if (checkedItems[item.id] && item) {
                acc.push({ id: item.id, tipo: item.tipo, ativo: true })
            }
            return acc
        }, [])

        if (data.length > 0) {
            const response = await ativarInativarMassa(estabelecimento.id, data, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                const idsToUpdate = new Set(data.map(itemData => itemData.id))

                items.forEach(item => {
                    if (item?.id && idsToUpdate.has(item.id)) {
                        item.ativo = true
                    } else if (item?.id && idsToUpdate.has(item.id)) {
                        item.ativo = true
                    }
                })
                alertStart("Disponibilidade dos itens alterada com sucesso", "success")
            }
        }

        setLoading(false)
    }

    const [openMassa, setOpenMassa] = useState(false)
    const handleModalAlteracao = () => {
        if (Object.values(checkedItems).filter(valor => valor === true).length >= 1) {
            setOpenMassa(prev => !prev)
        }
    }

    const handleClickAcrescentar = () => {
        setNovaAtividade("acrescentar")
        handleModalAlteracao()
        handleCloseMenu()
    }
    const handleClickDecrementar = () => {
        setNovaAtividade("decrementar")
        handleModalAlteracao()
        handleCloseMenu()
    }

    const handleClickDesativar = () => {
        setNovaAtividade("desativar")
        handleModalAlteracao()
        handleCloseMenu()
    }

    const handleClickAtivar = () => {
        setNovaAtividade("ativar")
        handleModalAlteracao()
        handleCloseMenu()
    }

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const handleSalvar = async () => {
        setLoading(true)

        const response = await salvarEdicaoEmMassa(estabelecimento.id, items, autorizacao)
        if (response.retornoErro) {
            alertStart("Erro ao salvar os produtos", "error")
        } else {
            alertStart("Produtos salvos com sucesso", "success")
        }

        setLoading(false)
    }

    const categorias = [...new Set(items?.map(item => item.categoria))]

    const handleSelectAllMenu = () => {
        handleSelectAll()
        handleCloseMenu()
    }

    const handleDeselectAllMenu = () => {
        handleDeselectAll()
        handleCloseMenu()
    }

    const handleSalvarMenu = () => {
        handleSalvar()
        handleCloseMenu()
    }

    return (
        <>
            <DialogConfirmacaoMassa
                open={openMassa}
                handleModalAlteracao={handleModalAlteracao}
                quantidade={Object.values(checkedItems).filter(valor => valor === true).length}
                acrescentar={acrescentar}
                decrementar={decrementar}
                ativar={ativar}
                desativar={desativar}
                novaAtividade={novaAtividade}
                setNovaAtividade={setNovaAtividade}
                checkedItems={checkedItems}
            />
            <Grid className={classes.container}>
                {isMobile ? (
                    <>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={8}>
                                <TextField
                                    type="text"
                                    id="buscarMassa"
                                    variant="outlined"
                                    placeholder="Buscar produtos..."
                                    size="small"
                                    fullWidth
                                    className={classes.searchField}
                                    value={textoBusca}
                                    onChange={e => {
                                        const value = e.target.value
                                        setTextoBusca(value)

                                        if (value.trim() === "") {
                                            setValorPesquisa("")
                                            setResetPagination(prev => !prev)
                                        }
                                    }}
                                    onKeyDown={handleBuscaKeyDown}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <IconButton
                                    className={classes.botaoBusca}
                                    onClick={procurarProduto}
                                >
                                    <Search />
                                </IconButton>
                            </Grid>

                            <Grid item xs={2}>
                                <IconButton
                                    className={classes.mobileMenuButton}
                                    onClick={handleOpenMenu}
                                >
                                    <MoreVert />
                                </IconButton>
                            </Grid>
                        </Grid>

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            classes={{ paper: classes.menuPaper }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        >
                            <MenuItem className={classes.menuItem}>
                                <FormControl fullWidth size="small" variant="outlined">
                                    <InputLabel>Categoria</InputLabel>
                                    <Select
                                        label="Categoria"
                                        value={categoriaSelecionada}
                                        onChange={handleChangeCategoriaSelecionada}
                                        style={{
                                            backgroundColor: "#fff",
                                            borderRadius: 15,
                                        }}
                                    >
                                        <MenuItem value={null}>Todas</MenuItem>
                                        {categorias?.map(categoria => (
                                            <MenuItem key={categoria} value={categoria}>
                                                {categoria}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </MenuItem>
                            <Divider />
                            <MenuItem className={classes.menuItem}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={7}>
                                        <TextField
                                            type="text"
                                            variant="outlined"
                                            placeholder="Valor"
                                            size="small"
                                            fullWidth
                                            className={classes.valorField}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                style: { textAlign: "right" },
                                            }}
                                            value={alterarValor}
                                            onChange={handleChangeAlterarValor}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <IconButton
                                            onClick={handleClickAcrescentar}
                                            style={{
                                                backgroundColor: "var(--cor-botao-salvar)",
                                                color: "white",
                                                marginRight: 4,
                                            }}
                                            size="small"
                                        >
                                            <Add />
                                        </IconButton>
                                        <IconButton
                                            onClick={handleClickDecrementar}
                                            style={{
                                                backgroundColor: "var(--cor-erro)",
                                                color: "white",
                                            }}
                                            size="small"
                                        >
                                            <Remove />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </MenuItem>
                            <Divider />
                            <MenuItem className={classes.menuItem} onClick={handleSelectAllMenu}>
                                Marcar Todos
                            </MenuItem>
                            <MenuItem className={classes.menuItem} onClick={handleDeselectAllMenu}>
                                Desmarcar Todos
                            </MenuItem>
                            <Divider />
                            <MenuItem className={classes.menuItem} onClick={handleClickAtivar}>
                                Ativar Selecionados
                            </MenuItem>
                            <MenuItem className={classes.menuItem} onClick={handleClickDesativar}>
                                Desativar Selecionados
                            </MenuItem>
                            <Divider />
                            <MenuItem className={classes.menuItem} onClick={handleSalvarMenu}>
                                <strong style={{ color: "#4caf50" }}>Salvar Alterações</strong>
                            </MenuItem>
                        </Menu>
                    </>
                ) : (
                    <>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={12} md={5}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={10}>
                                        <TextField
                                            type="text"
                                            id="buscarMassa"
                                            variant="outlined"
                                            placeholder="Buscar produtos por nome..."
                                            size="small"
                                            fullWidth
                                            className={classes.searchField}
                                            value={textoBusca}
                                            onChange={e => {
                                                const value = e.target.value
                                                setTextoBusca(value)

                                                if (value.trim() === "") {
                                                    setValorPesquisa("")
                                                    setResetPagination(prev => !prev)
                                                }
                                            }}
                                            onKeyDown={handleBuscaKeyDown}
                                        />
                                    </Grid>

                                    <Grid item xs={2}>
                                        <IconButton
                                            className={classes.botaoBusca}
                                            onClick={procurarProduto}
                                        >
                                            <Search />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth size="small" variant="outlined">
                                    <InputLabel>Categoria</InputLabel>
                                    <Select
                                        label="Categoria"
                                        value={categoriaSelecionada}
                                        onChange={handleChangeCategoriaSelecionada}
                                        style={{
                                            backgroundColor: "#fff",
                                            borderRadius: 15,
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        <MenuItem value={null}>Todas</MenuItem>
                                        {categorias?.map(categoria => (
                                            <MenuItem key={categoria} value={categoria}>
                                                {categoria}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={7}>
                                        <TextField
                                            type="text"
                                            variant="outlined"
                                            placeholder="Acrésc./Decrés."
                                            size="small"
                                            fullWidth
                                            className={classes.valorField}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                style: { textAlign: "right" },
                                            }}
                                            value={alterarValor}
                                            onChange={handleChangeAlterarValor}
                                        />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <IconButton
                                            onClick={handleClickAcrescentar}
                                            style={{
                                                backgroundColor: "var(--cor-botao-salvar)",
                                                color: "white",
                                                marginRight: 4,
                                                "&:hover": {
                                                    backgroundColor: "var(--cor-botao-salvar-hover)",
                                                },
                                            }}
                                            size="small"
                                        >
                                            <Add />
                                        </IconButton>
                                        <IconButton
                                            onClick={handleClickDecrementar}
                                            style={{
                                                backgroundColor: "var(--cor-erro)",
                                                color: "white",
                                                "&:hover": {
                                                    backgroundColor: "var(--cor-erro-hover)",
                                                },
                                            }}
                                            size="small"
                                        >
                                            <Remove />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider className={classes.divider} />

                        <Grid container spacing={2}>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    className={classes.botaoMarcar}
                                    onClick={handleSelectAll}
                                >
                                    Marcar Todos
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    className={classes.botaoMarcar}
                                    onClick={handleDeselectAll}
                                >
                                    Desmarcar Todos
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    className={classes.botaoDesativar}
                                    onClick={handleClickDesativar}
                                >
                                    Desativar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    className={classes.botaoAtivar}
                                    onClick={handleClickAtivar}
                                >
                                    Ativar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    className={
                                        filtroPDV
                                            ? classes.botaoPDVAtivado
                                            : classes.botaoPDVDesativado
                                    }
                                    onClick={() => {
                                        setFiltroPDV(prev => !prev)
                                    }}
                                >
                                    Sem Código PDV
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    className={classes.botaoSalvar}
                                    onClick={handleSalvar}
                                >
                                    Salvar
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}

                <Divider className={classes.divider} />

                <Grid className={classes.containerList}>
                    <PaginatedList
                        items={itensMostrar}
                        resetPagination={resetPagination}
                        handleCadastrarImagem={handleCadastrarImagem}
                        handleInputChange={handleInputChange}
                        setItems={setItems}
                        estabelecimento={estabelecimento}
                    />
                </Grid>
            </Grid>
        </>
    )
}
